/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const InviteMemberResponse = zod
	.object({
		invitation_id: zod.string().describe('Invitation ID'),
		message: zod.string().describe('Status message')
	})
	.describe('Invitation creation response');

export type InviteMemberResponse = zod.input<typeof InviteMemberResponse>;
export type InviteMemberResponseOutput = zod.output<typeof InviteMemberResponse>;
